import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (<
    Typewriter options={
      {
        strings: [
          "DevOps Engineer",
          "Cloud Computing Enthusiast",
          "Back-End Developer",
          "Hobbyist Video Game Player",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }
    }
  />
  );
}

export default Type;